import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

import {NGXLogger} from 'ngx-logger';
import {Observable, of as observableOf} from 'rxjs';

import {catchError, map} from 'rxjs/operators';

import {MetaData, MetaDataInterface} from '../model/meta-data.model';
import {AstronomicalDataService} from '../service/astronomical-data.service';

@Injectable()
export class UploadResolver {

  constructor(private astronomicalDataService: AstronomicalDataService,
              private logger: NGXLogger,
              private router: Router) {
    this.logger.debug('UploadResolver: constructing.');
  }

  resolve(): Observable<MetaData[]> {
    this.logger.debug('UploadResolver: Waiting for upload data to be available.');

    return this.astronomicalDataService.getAllAstronomicalPredictionsMetaData().pipe(
      map((items: MetaDataInterface[]) => {
        const metadata: MetaData[] = [];
        items.forEach((item: MetaDataInterface) => {
          metadata.push(new MetaData(item));
        });
        return metadata;
      }),
      catchError((error) => {
        if (error === 404) {
          this.router.navigate(['404']);
        } else {
          this.router.navigate(['error']);
        }
        return observableOf(null);
      }),);
  }
}
